import React, { FC, useRef, useState } from 'react';

import cn from 'classnames';
import dayjs from 'dayjs';

import WapperIcon from '@components/Icon';
import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect'
import { I18n } from '@utils/index';

import { timer } from '../timer';

import styles from './index.module.less';

interface TimeProps {
  endTime: number,
  className?: string,
  /** 倒计时结束的回调 */
  cb?: () => void;
}
export const BCD: FC<TimeProps> = (props) => {
  const { endTime, className, cb } = props;
  const [total, setTotal] = useState<number>(endTime - dayjs().unix());
  const [deadline, setDeadline] = useState<string>('');
  const timeRef = useRef(null);
  const countdown = () => {
    const timers = timer(total);
    if (total > 1) {
      setDeadline(`${timers.hours}:${timers.minutes}:${timers.seconds}`);
      setTotal(endTime - dayjs().unix());
    } else {
      setDeadline('00:00:00');
      setTotal(0);
      clearInterval(timeRef.current);
      cb?.()
    }
  }
  useIsomorphicLayoutEffect(() => {
    countdown();
    timeRef.current = setInterval(() => {
      countdown();
    }, 1000);
    return () => {
      clearInterval(timeRef.current);
    }
  }, [total])
  return (
    <div className={cn(styles.wrapper, className)}>
        <WapperIcon name="timeSvg" className={styles.timeIcon}/>
        <span className={styles.time}>{I18n.t('2gqdBiHE')}: {deadline}</span>
    </div>
  );
};
